var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "user-questionnaire-form-container w-100 user-modal-register-view px-2",
      style: _vm.containerStyle,
    },
    [
      [
        _c(
          "div",
          { staticClass: "w-100 mb-4" },
          [
            _c("div", { staticClass: "mb-2 text-center" }, [
              _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
                _vm._v(_vm._s(_vm._f("trans")("Tell us about yourself"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-2 text-center py-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("trans")(
                      "And we'll personalize your experience for %project%!",
                      { "%project%": _vm.projectName }
                    )
                  ) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("DotNavigation"),
            _vm._v(" "),
            _c("div", { staticClass: "text-center py-2 mb-2" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("How do you mainly use %project%?", {
                      "%project%": _vm.projectName,
                    })
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.isStatusDone
              ? _c("div", [
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info":
                            _vm.dataValue === "Administrative task processing",
                          "btn btn-white":
                            _vm.dataValue !== "Administrative task processing",
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.openFreeForm = false
                            _vm.dataValue = "Administrative task processing"
                            _vm.goToWorkEnvironment()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("trans")("Administrative task processing")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info":
                            _vm.dataValue ===
                            "Legal document management (contracts, invoices, etc.)",
                          "btn btn-white":
                            _vm.dataValue !==
                            "Legal document management (contracts, invoices, etc.)",
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.openFreeForm = false
                            _vm.dataValue =
                              "Legal document management (contracts, invoices, etc.)"
                            _vm.goToWorkEnvironment()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("trans")(
                                "Legal document management (contracts, invoices, etc.)"
                              )
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info":
                            _vm.dataValue === "Prepare material to send away",
                          "btn btn-white":
                            _vm.dataValue !== "Prepare material to send away",
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.openFreeForm = false
                            _vm.dataValue = "Prepare material to send away"
                            _vm.goToWorkEnvironment()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("trans")("Prepare material to send away")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-5" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info": _vm.openFreeForm === true,
                          "btn btn-white": _vm.openFreeForm === false,
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.dataValue = ""
                            _vm.openFreeForm = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("trans")("Other")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.openFreeForm
                    ? _c(
                        "div",
                        { staticClass: "mx-auto p-0 mb-4" },
                        [
                          _c("TextArea", {
                            attrs: {
                              name: "form",
                              type: "text",
                              label: _vm.getPlaceholder,
                              "max-characters": 180,
                            },
                            model: {
                              value: _vm.dataValue,
                              callback: function ($$v) {
                                _vm.dataValue = $$v
                              },
                              expression: "dataValue",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm.isStatusLoading
              ? _c("LoadingAnimation", {
                  attrs: { "animation-style": "bars", classes: "mb-4" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.openFreeForm
              ? _c("ButtonWithLoadingState", {
                  staticClass:
                    "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
                  attrs: {
                    "data-user-modal-button-submit": "",
                    icon: "fa fa-arrow-right lh-1",
                    text: _vm._f("trans")("Continue"),
                    "is-state-loading": _vm.isSubmitting,
                    "show-icon-after-text": true,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToWorkEnvironment.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-lg",
                  attrs: { disabled: _vm.isSubmitting },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onBackButtonClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm._f("trans")("Back")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }